import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export type Testimonial = {
  initials: string;
  quote: string;
  author: string;
  role: string;
};
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="py-16 px-6 max-w-7xl mx-auto" data-id="element-256">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-257">
        {testimonials.map((t, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-petroleo rounded-2xl p-8 border border-tealBrand/20 flex flex-col h-full" data-id="element-258">
            <div className="flex items-center gap-4 mb-6" data-id="element-259">
              <div className="w-12 h-12 rounded-full bg-tealBrand flex items-center justify-center text-noche font-bold text-lg" data-id="element-260">
                {t.initials}
              </div>
              <div className="flex text-amarillo" data-id="element-261">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-262" />)}
              </div>
            </div>
            <p className="text-gray-200 italic mb-6 flex-grow" data-id="element-263">"{t.quote}"</p>
            <div data-id="element-264">
              <div className="font-bold text-white" data-id="element-265">{t.author}</div>
              <div className="text-sm text-tealBrand" data-id="element-266">{t.role}</div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}